import React, { FC } from 'react';
import cls from 'classnames';

import { Routes } from 'src/prize/services/Routes';
import { ICollection } from 'src/prize/types/shoppe';

import styles from './index.module.sass';

interface ICollectionProps {
  data: ICollection;
  isActive: boolean;
}

export const Collection: FC<ICollectionProps> = ({ data: { permalink, title }, isActive }) => (
  <a
    aria-current={isActive ? 'page' : undefined}
    className={cls( styles.collection, { [styles.inactive]: !isActive, [styles.active]: isActive })}
    href={Routes.categories( permalink )}
  >
    {title}
  </a>
);
